var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { name: "fadeFooter", mode: "out-in", appear: "" } },
    [
      _c("div", { staticClass: "footer" }, [
        _c(
          "span",
          {
            staticClass: "footer-text license",
            staticStyle: { "margin-left": "10px" }
          },
          [
            _vm._v(
              "WEEZIE FIBER @2025 " +
                _vm._s(_vm.$t("LicensedTo")) +
                " " +
                _vm._s(_vm.host) +
                " - " +
                _vm._s(_vm.version) +
                " "
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "socials-container" }, [
          _c(
            "a",
            {
              staticClass: "footer-text",
              staticStyle: { "text-transform": "lowercase" },
              attrs: { href: "https://weezie.io/", target: "_blank" }
            },
            [_vm._v("weezie.io")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: "https://www.instagram.com/weezieofficial/",
                target: "_blank"
              }
            },
            [
              _c(
                "v-badge",
                {
                  staticClass: "footer-badge",
                  attrs: {
                    content: "",
                    value: null,
                    color: "accent",
                    tile: "",
                    bordered: "",
                    dark: "",
                    overlap: ""
                  }
                },
                [
                  _c(
                    "v-btn",
                    { attrs: { icon: "" } },
                    [
                      _c(
                        "v-icon",
                        { attrs: { color: "#231E46", size: "24" } },
                        [_vm._v("mdi-instagram")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: "https://www.facebook.com/weeziesoftware/",
                target: "_blank"
              }
            },
            [
              _c(
                "v-badge",
                {
                  staticClass: "footer-badge",
                  attrs: {
                    content: "",
                    value: null,
                    color: "accent",
                    tile: "",
                    bordered: "",
                    dark: "",
                    overlap: ""
                  }
                },
                [
                  _c(
                    "v-btn",
                    { attrs: { icon: "" } },
                    [
                      _c(
                        "v-icon",
                        { attrs: { color: "#231E46", size: "24" } },
                        [_vm._v("mdi-facebook")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: "https://www.twitter.com/weeziesoftware/",
                target: "_blank"
              }
            },
            [
              _c(
                "v-badge",
                {
                  staticClass: "footer-badge",
                  attrs: {
                    content: "",
                    value: null,
                    color: "accent",
                    tile: "",
                    bordered: "",
                    dark: "",
                    overlap: ""
                  }
                },
                [_c("v-btn", { attrs: { icon: "" } }, [_c("TwitterLogo")], 1)],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: "https://www.linkedin.com/company/weezie-io/",
                target: "_blank"
              }
            },
            [
              _c(
                "v-badge",
                {
                  staticClass: "footer-badge",
                  attrs: {
                    content: "",
                    value: null,
                    color: "accent",
                    tile: "",
                    bordered: "",
                    dark: "",
                    overlap: ""
                  }
                },
                [
                  _c(
                    "v-btn",
                    { attrs: { icon: "" } },
                    [
                      _c(
                        "v-icon",
                        { attrs: { color: "#231E46", size: "24" } },
                        [_vm._v("mdi-linkedin")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-827b2194", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-827b2194","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hub/HubFooter.vue
// module id = null
// module chunks = 